export const LOCALS = {
  UK: 'uk',
  EN: 'en',
  DE: 'de',
  RU: 'ru',
}
